import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import { utilities } from "../components/utilities";
import {
  prepareContentUrl,
  README_FILE_NAME,
  TRAINING_PROJECT,
} from "../constants/oneDriveConstants";
import { getFileFromOneDrive } from "../Office365/Office365Graph";
import { appContext } from "../Office365/Office365Context";
import { GET_MY_TRAININGS } from "../constants/urlConstants";
import { withRouter } from "react-router-dom";
import { Loader } from "../components/customComponents";

const MyTrainings = (props) => {
  const context = useContext(appContext);
  const [masterTrainings, setMasterTrainings] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector(
    (state) => state.CurrentUserReducer.currentUserDetail
  );

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        let master = [];

        // Fetch master trainings
        if (context?.authProvider) {
          const readmePath = prepareContentUrl(TRAINING_PROJECT, README_FILE_NAME);
          const response = await getFileFromOneDrive(context.authProvider, readmePath);
          master = response?.training_history_data || [];
          setMasterTrainings(master); // Save for future use
        }

        // Fetch user trainings
        const postData = { employee_id: user.employee_id };
        const res = await Axios.post(GET_MY_TRAININGS, postData);

        if (res?.data && !res.data.errorMessage) {
          const trainingsWithProgress = res.data.map((training) => {
            const matchingMaster = master.find(
              (m) => m.training_id === training.training_id
            );
            const progress = matchingMaster?.modules?.length
              ? Math.round(
                  (training.module_count / matchingMaster.modules.length) * 100
                )
              : training.progress_percentage || 0;
            return {
              ...training,
              progress_percentage: progress,
            };
          });
          setTrainingList(trainingsWithProgress);
        }
      } catch (error) {
        utilities.showToast(error.message || "Error loading trainings");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [context?.authProvider, user.employee_id]);

  const handleTrainingClick = (training) => {
    // Replace '32323986' with a dynamic training ID if available
    props.history.push(
      `/trainings/completed/${training.training_id}/${training.training_name}`
    );
  };

  return (
    <div className="page-wrap">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <h4>My Trainings</h4>
          {trainingList.length === 0 ? (
            <div>No trainings found.</div>
          ) : (
            <table className="table table-striped table-bordered table-hover training-history-table">
              <thead>
                <tr>
                  <th>Training Name</th>
                  <th>Progress</th>
                </tr>
              </thead>
              <tbody>
                {trainingList.map((training, idx) => (
                  <tr key={training.training_id || idx}>
                    <td>
                      <span
                        className="link-decor"
                        role="button"
                        tabIndex={0}
                        onClick={() => handleTrainingClick(training)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") handleTrainingClick(training);
                        }}
                      >
                        {training.training_name}
                        {training.progress_percentage === 100 && (
                          <i
                            className="fa fa-check-circle"
                            style={{ color: "green", marginLeft: "1%" }}
                          />
                        )}
                      </span>
                    </td>
                    <td>
                      <span>{training.progress_percentage}%</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
};

export default withRouter(MyTrainings);
